export function fallBackTranslation(fallbackNs: string, t) {
  const t2 = (_: string) => t(_, { ns: fallbackNs });
  const fallbackT = (_: string) => (_ === t(_) ? t2(_) : t(_));
  return fallbackT;
}
